import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import StartFormFields from '../shared/forms/start';
import analytics from '../../lib/analytics';
import { FlexContainerRowLRPadding, FormNavButtons, PageWrapper, } from '../styled/skylab/page';
import { SignUpForm } from '../styled/components/sign-up';
import Banner from '../banner';
import CheckoutPurchaseInfo from './checkout-purchase-info';
import { showThirdBullet as shouldShowThirdBullet } from '../helpers/sign-up';
import { isFormOneIncomplete } from '../../lib/shared-signup';
import { getPartnerSignupConnectorByCode } from '../../../shared/constants';
import { selectState } from '../../selectors';
import conf from '../../conf';
const Start = () => {
    const { abTesting: { group: abGroup }, avataxSignup: { partnerSignup }, data: { connectors: { data: connectors } }, sharedSignup, system: { activeFlow }, } = useSelector(selectState);
    const isDirectToBuy = Boolean(partnerSignup) && activeFlow === 'avatax-direct-buy';
    const disableNextButton = isFormOneIncomplete(sharedSignup);
    const showThirdBullet = shouldShowThirdBullet(abGroup, partnerSignup);
    const searchParams = new URLSearchParams(window.location.search);
    useEffect(() => {
        var _a;
        const partner = (searchParams.get('partner') || '').toUpperCase();
        const connectorId = (_a = getPartnerSignupConnectorByCode(partner)) === null || _a === void 0 ? void 0 : _a.connectorId;
        const connector = connectors.find(c => (c.id === connectorId)) || {};
        if ((connector === null || connector === void 0 ? void 0 : connector.name) == null)
            return;
        analytics.page('SIGNUP_START', { connector: connector.name, abBucket: abGroup });
    }, []);
    return (React.createElement("div", null,
        React.createElement(Banner, { backgroundImage: `${conf.ASSET_PATH}/assets/images/banner-background.png`, image: `${conf.ASSET_PATH}/assets/images/account_w.svg`, partnerSignup: partnerSignup, primaryText: 'Avalara AvaTax', secondaryText: 'Tax compliance done right' }),
        React.createElement(PageWrapper, null,
            React.createElement(FlexContainerRowLRPadding, null,
                React.createElement("div", null,
                    React.createElement("h3", { "data-ref": 'buy.signup.start.heaader', className: 'text-md' }, "Get started quickly"),
                    React.createElement(SignUpForm, null,
                        React.createElement(StartFormFields, { disableNextButton: disableNextButton }),
                        React.createElement("br", null)),
                    React.createElement(FormNavButtons, null,
                        React.createElement(Link, { to: `/buy/company?${searchParams}` },
                            React.createElement("button", { "data-ref": 'buy.signup.start.next-button', className: 'primary large', disabled: disableNextButton }, 'Continue')))),
                React.createElement(CheckoutPurchaseInfo, { start: true, partnerSignup: partnerSignup, isDirectToBuy: isDirectToBuy, showThirdBullet: showThirdBullet })))));
};
export default Start;
